import { render, staticRenderFns } from "./account-manage-table.vue?vue&type=template&id=81b0599a&scoped=true"
import script from "./account-manage-table.vue?vue&type=script&lang=js"
export * from "./account-manage-table.vue?vue&type=script&lang=js"
import style0 from "./account-manage-table.vue?vue&type=style&index=0&id=81b0599a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81b0599a",
  null
  
)

export default component.exports